var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFerris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "c210d4c3-50f6-4b50-8e0f-1137d9acd797"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "9d64feab-2c9c-4ec2-864c-6c1e6f2df709"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 539.99 533.48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(551.27, -119.75)",
    d: "M 0 240.343 L -93.415 171.532 C -94.295 168.468 -95.171 165.405 -96.077 162.37 L -65.394 117.919 C -62.264 113.397 -61.629 107.521 -63.663 102.364 C -65.7 97.234 -70.154 93.554 -75.426 92.654 L -127.31 83.849 C -129.318 79.747 -131.426 75.707 -133.54 71.699 L -111.743 21.796 C -109.5 16.709 -109.974 10.801 -112.946 6.188 C -115.907 1.552 -120.936 -1.156 -126.295 -0.945 L -178.951 0.968 C -181.678 -2.582 -184.447 -6.1 -187.272 -9.553 L -175.172 -63.043 C -173.947 -68.476 -175.494 -74.161 -179.275 -78.107 C -183.037 -82.039 -188.504 -83.666 -193.701 -82.39 L -244.99 -69.782 C -248.311 -72.717 -251.688 -75.615 -255.104 -78.455 L -253.256 -133.369 C -253.058 -138.928 -255.649 -144.211 -260.1 -147.294 C -264.546 -150.398 -270.193 -150.867 -275.056 -148.56 L -322.903 -125.813 C -326.757 -128.023 -330.631 -130.213 -334.547 -132.33 L -343.002 -186.445 C -343.859 -191.928 -347.387 -196.584 -352.328 -198.711 C -357.251 -200.848 -362.896 -200.158 -367.219 -196.903 L -409.878 -164.896 C -414.078 -166.291 -418.297 -167.628 -422.57 -168.907 L -440.956 -220.223 C -442.826 -225.452 -447.137 -229.294 -452.394 -230.374 C -457.633 -231.446 -463.024 -229.632 -466.657 -225.572 L -502.563 -185.401 C -506.906 -185.901 -511.249 -186.357 -515.606 -186.732 L -543.33 -233.445 C -546.14 -238.177 -551.1 -241.057 -556.446 -241.057 C -561.78 -241.057 -566.75 -238.177 -569.536 -233.445 L -597.269 -186.732 C -601.627 -186.357 -605.991 -185.901 -610.325 -185.401 L -646.235 -225.572 C -649.871 -229.632 -655.282 -231.446 -660.503 -230.374 C -665.758 -229.282 -670.076 -225.452 -671.936 -220.223 L -690.338 -168.907 C -694.598 -167.628 -698.819 -166.28 -703.029 -164.896 L -745.673 -196.903 C -750.009 -200.169 -755.653 -200.858 -760.589 -198.711 C -765.508 -196.584 -769.05 -191.928 -769.902 -186.445 L -778.363 -132.33 C -782.277 -130.213 -786.152 -128.036 -790.016 -125.813 L -837.858 -148.56 C -842.716 -150.876 -848.387 -150.398 -852.812 -147.294 C -857.257 -144.211 -859.854 -138.928 -859.652 -133.369 L -857.817 -78.455 C -861.222 -75.615 -864.591 -72.717 -867.929 -69.782 L -919.208 -82.39 C -924.418 -83.655 -929.878 -82.039 -933.649 -78.107 C -937.444 -74.161 -938.98 -68.476 -937.762 -63.043 L -925.683 -9.553 C -928.485 -6.086 -931.258 -2.582 -933.976 0.968 L -986.631 -0.945 C -991.945 -1.102 -997.017 1.552 -999.987 6.188 C -1002.96 10.801 -1003.41 16.709 -1001.2 21.796 L -979.384 71.699 C -981.503 75.707 -983.608 79.747 -985.633 83.849 L -1037.52 92.654 C -1042.79 93.542 -1047.23 97.22 -1049.28 102.364 C -1051.32 107.521 -1050.65 113.397 -1047.55 117.919 L -1016.85 162.37 C -1017.09 163.154 -1017.31 163.947 -1017.55 164.734 L -1104.32 256.904 C -1104.32 256.904 -1117.61 267.327 -1098.25 291.82 C -1081.18 313.425 -993.526 399.072 -947.232 443.943 C -927.678 466.722 -914.284 480.829 -912.883 479.609 C -910.675 477.669 -922.27 436.224 -960.785 387.597 C -990.47 343.968 -1029 276.864 -1019.96 269.13 C -1019.96 269.13 -1009.69 256.085 -989.067 246.695 C -988.314 247.298 -989.848 246.097 -989.067 246.695 C -989.067 246.695 -553.915 447.427 -150.27 250.091 C -104.162 241.818 -76.247 266.521 -76.247 266.521 C -66.619 272.101 -91.548 341.099 -112.045 386.775 C -139.926 438.638 -144.015 479.107 -141.649 480.511 C -140.158 481.4 -130.015 465.966 -115.545 441.402 C -79.843 391.654 -12.354 296.816 0 273.782 C 14.006 247.663 0 240.343 0 240.343",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 554.09 629.16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-16.75, 139.78)",
    d: "M 0 -279.559 C -121.238 -279.559 -231.39 -264.983 -312.939 -241.23 L -312.939 -38.329 C -231.39 -14.575 -121.238 0 0 0 C 138.76 0 262.987 -19.092 346.431 -49.186 L 346.431 -230.37 C 262.987 -260.465 138.76 -279.559 0 -279.559",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 955.99 680.43)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(52.76, 27.14)",
    d: "M 0 -53.32 L -14.211 -82.761 C -14.138 -83.879 -14.08 -84.998 -14.08 -86.121 C -14.08 -119.496 -48.786 -150.256 -107.177 -174.883 L -107.177 2.643 C -79.932 -8.849 -57.829 -21.674 -42.021 -35.482 C -46.673 -16.775 -62.585 21.071 -75.271 47.686 C -96.121 85.752 -103.671 118.889 -102.703 120.53 C -102.086 121.563 -94.973 110.59 -84.484 92.809 C -60.074 58.028 -13.82 -8.373 -4.575 -25.287 C 5.897 -44.461 0 -53.32 0 -53.32",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 153.4 672.89)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-64.34, 50.46)",
    d: "M 0 -99.954 C 0 -93.526 1.293 -87.194 3.788 -80.985 L -4.723 -65.835 C -4.723 -65.835 -11.541 -56.989 0.465 -38.327 C 11.055 -21.872 64.1 42.54 92.097 76.271 C 104.123 93.564 112.276 104.216 112.99 103.187 C 114.114 101.554 105.514 69.087 81.631 32.046 C 70.487 12.151 57.177 -14.206 49.189 -33.675 C 71.492 -19.559 100.672 -6.755 135.341 4.265 L 135.341 -204.17 C 51.797 -177.622 0 -140.737 0 -99.954",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 342.15 787.81)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(39.24, 31.76)",
    d: "M 0 -25.102 C 91.833 -36.676 144.904 -37.754 144.904 -37.754 C 22.037 -199.838 -77.661 -53.098 -77.661 -53.098 C -102.643 -62.03 -128.114 -96.711 -147.138 -128.688 L -223.375 -151.268 C -135.502 -2.127 -70.08 0.146 -70.08 0.146 C 66.134 174.736 130.663 34.441 130.663 34.441 C 54.195 25.759 0 -25.102 0 -25.102",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 420.66 737.64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-30.34, -122.08)",
    d: "M 0 167.33 C -1.664 165.91 -2.536 165.068 -2.536 165.068 L 140.006 153.391 C 23.733 0 -69.418 122.193 -79.333 135.855 L -79.333 167.33 L 0 167.33 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 659.56 735.16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(27.56, -125.9)",
    d: "M 0 171.974 C 1.663 170.554 2.536 169.71 2.536 169.71 L -134.448 159.687 C -18.12 0 69.421 126.835 79.335 140.497 L 79.335 171.974 L 0 171.974 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 749.46 762.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(156.63, 180.41)",
    d: "M 0 -314.014 C 0 -314.014 -15.576 -251.973 -112.453 -186.776 L -139.619 -180.409 C -139.619 -180.409 -227.5 -340.668 -352.002 -160.075 C -352.002 -160.075 -313.2 -182.666 -209.18 -155.155 C -209.18 -155.155 -257.03 -81.916 -353.422 -84.166 C -353.422 -84.166 -261.049 26.654 -120.482 -133.418 C -120.482 -133.418 28.113 -190.881 40.164 -314.014 L 0 -314.014 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 660.19 596.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41,
      fill: "rgb(13,13,13)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-42.8, 45.15)",
    d: "M 0 -92.063 C 0 -92.063 43.486 -139.678 86.974 -92.063 C 86.974 -92.063 121.144 -28.571 86.974 3.171 C 86.974 3.171 31.062 47.615 0 3.171 C 0 3.171 -37.275 -31.75 0 -92.063",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 643.33 567.14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(24.41, 0)",
    d: "M 0 0.002 C 0 18.543 -10.93 33.574 -24.408 33.574 C -37.885 33.574 -48.814 18.543 -48.814 0.002 C -48.814 -18.539 -37.885 -33.572 -24.408 -33.572 C -10.93 -33.572 0 -18.539 0 0.002",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 459.54 598.52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41,
      fill: "rgb(13,13,13)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-36.24, 36.39)",
    d: "M 0 -98.439 C 0 -98.439 74.596 -131.467 94.956 -57.748 C 94.956 -57.748 116.283 28.178 33.697 33.028 C 33.697 33.028 -71.613 12.745 0 -98.439",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 435.59 568.35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(25.17, 0)",
    d: "M 0 0 C 0 19.119 -11.27 34.627 -25.173 34.627 C -39.071 34.627 -50.344 19.119 -50.344 0 C -50.344 -19.124 -39.071 -34.627 -25.173 -34.627 C -11.27 -34.627 0 -19.124 0 0",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerris);
export default __webpack_public_path__ + "static/media/ferris.7e8ef2e062eec4981ebddcf2c3bc0316.svg";
export { ForwardRef as ReactComponent };